// utils.js
export const openPDF = () => {
  const pdfUrl = 'OASIS_Data_Portal_User_Guide_v3.pdf';
  window.open(pdfUrl, '_blank');
};
